import { ROUTES, TITLES, PROD, STAGE, DEV } from 'consts';

export const APARTMENT_LIST_MENU = {
  key: ROUTES.APARTMENT_LIST.ROOT,
  label: TITLES[ROUTES.APARTMENT_LIST.ROOT],
  environment: [DEV, STAGE, PROD],
};
